import React from "react";
import { Space, Typography, Button } from "antd";

const { Title, Text, Link } = Typography;

export default function Footer() {
  return (
    <>
      <Space
        align={"center"}
        direction={"vertical"}
        size={3}
        style={{ padding: "5rem 0", backgroundColor: "#F0F0F0" }}
        className="center-content"
      >
        <Title level={3}>Do you find it useful?</Title>
        <Text>Leave your feedback now! It will help improving the tool.</Text>
        <div className="divider-small"></div>

        <Button
          type="primary"
          href="https://forms.gle/Y3Sd12sRYzext7py5"
          target="_blank"
        >
          Fill the form
        </Button>
      </Space>
      <Space
        align={"center"}
        direction={"vertical"}
        size={3}
        style={{
          padding: "2rem 0",
          backgroundColor: "#1F1F1F",
        }}
        className="center-content"
      >
        <Text style={{ color: "#D9D9D9" }}>
          Visual Content Assessment Tool | A project by{" "}
          <Link
            style={{ color: "#D9D9D9", textDecoration: "underline" }}
            href="https://en.wikipedia.org/wiki/User:MingoBerlingo"
            target="_blank"
          >
            User:MingoBerlingo
          </Link>
        </Text>
      </Space>
    </>
  );
}
